import { TimePickerTheme } from '@medly-components/theme';
import colors from './colors';

export const timePicker: TimePickerTheme = {
    bgColor: colors.white,
    borderRadius: `0.4rem`,
    shadowColor: '#B0BCC8',
    label: {
        fontSize: '16px',
        fontWeight: 'Medium',
        lineHeight: '22px',
        color: colors.grey[700],
        letterSpacing: '0'
    },
    selectedOption: {
        fontSize: '20px',
        fontWeight: 'Strong',
        lineHeight: '22px',
        letterSpacing: '0',
        color: colors.darkBlue,
        hoverColor: colors.coral[500],
        backgroundColor: colors.grey[200]
    },
    nonSelectedOption: {
        fontSize: '16px',
        fontWeight: 'Medium',
        lineHeight: '22px',
        color: colors.grey[500],
        hoverColor: colors.grey[500],
        letterSpacing: '0'
    }
};
